import { axios } from 'services/axios';

/**
 * Delete a partner by ID
 * @param {string} partnerId - The ID of the partner to delete
 * @returns {Promise} Response from the server
 */
const deletePartner = async (partnerId) => {
    const response = await axios.delete(`/partner/${partnerId}`);
    return response.data;
};

export default deletePartner;
